import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=4c8db6d8&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=4c8db6d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8db6d8",
  null
  
)

export default component.exports